const it = {
    locale: {
        en: "EN",
        it: "IT",
    },
    user: {
        profile: "Profilo utente",
        account: "Account",
        logout: "Disconnetti",
        login: "Accedi",
        support: "Supporto",
        name: "Nome",
        email: "Email",
        verified: "Email verificata",
        modify: "Modifica",
        save: "Salva modifiche",
        resetPasswordMessage: "Un'email è stata inviata al tuo indirizzo con le istruzioni per cambiare la password",
        resendEmail: "invia nuovamente",
        resendEmailMessage: "Un'email è stata inviata al tuo indirizzo con le istruzioni per la verifica dell'account. Dopo aver verificato il tuo account, ricarica questa pagina",
    },
    generic: {
        yes: "Sì",
        no: "No",
    },
    error: {
        page: "Errore",
        forbidden: "Accesso negato",
        notFound: "Pagina non trovata",
        notAuthenticated: "Utente non autenticato",
    },
    kptable: {
        filters: "Filtri",
        apply: "Applica",
        reset: "Resetta",
        show_columns: "Mostra colonne",
        pager: {
            first: "Prima",
            last: "Ultima",
        },
        actions: "Azioni",
        date: {
            short: "DD/MM/YYYY",
            long: "DD/MM/YYYY HH:mm",
        },
        confirm: {
            title: "Conferma",
            yes: "Sì",
            no: "No",
        },
        show: "Mostra",
        globalSelectionWarn1: "Sono stati selezionati tutti gli elementi di questa pagina .",
        globalSelectionWarn2: "Tutti gli elementi sono stati selezionati. ",
        globalSelectionWarnAll: "Seleziona tutti gli elementi",
        globalSelectionWarnNotAll: "Cancella la selezione",
        globalSelectionFilterWarn1: "(Tutti i filtri attivi saranno considerati nella selezione)",
        globalSelectionFilterWarn2: "(Tutti i filtri attivi sono considerati nella selezione)",
        genericFilterError: "Devi aggiungere un filtro o modificare uno esistente",
    },
};
export default it;
